export default __webpack_public_path__ + "static/media/reportIcon.43e0c824.svg";